import React from 'react';

// import withMobileDialog from '@mui/material/withMobileDialog';
import { useTheme, useMediaQuery } from '@mui/material';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

// const styles = theme => ({
//     root: {
//       margin: 0,
//       padding: theme.spacing(2)
//     },
    // closeButton: {
    //   position: 'absolute',
    //   right: theme.spacing(1),
    //   top: theme.spacing(1),
    //   color: theme.palette.grey[500],
    // },
//   });

export default function DialogBox(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { close, title, scroll, disableBackdropClick } = props;
    return (
        <Dialog
            open={true}
            // onClose={close}
            onClose={(_, reason) => {disableBackdropClick ? reason !== "backdropClick" && close() : close() } }
            aria-labelledby="form-dialog-title"
            maxWidth={props.maxWidth || "sm"}
            fullScreen={fullScreen}
            fullWidth
            scroll={scroll || "body"}
            sx={{
                zIndex: 10002,
                '& .MuiBackdrop-root': {
                    zIndex: 10002,
                },
                '& .MuiDialog-container': {
                    zIndex: 10002,
                },
                '& .MuiDialog-paper': {
                    zIndex: 10002,
                },
            }}
        >
            <DialogTitle className="" disableTypography>
            {/* <DialogTitle className="" disableTypography  className={classes.root}> */}
                <Typography variant="subtitle1">{title}</Typography>
                {close ? (
                    <IconButton aria-label="Close" onClick={close} style={{
                        position: 'absolute',
                        right: theme.spacing(1),
                        top: theme.spacing(1),
                        color: theme.palette.grey[500],
                      }}>
                    {/* <IconButton aria-label="Close" className={classes.closeButton} onClick={close}> */}
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
                <p className="dialog-banner-footer"></p>
            <DialogContent>
                {props.children[0] || props.children }
            </DialogContent>
            {props.children[1] &&
            
            <DialogActions>
                {props.children[1]}
            </DialogActions>
            }
        </Dialog>
    );
}
  
// export default withStyles(styles)(DialogBox)